import PropTypes from 'prop-types';

import { FadeInAnimation, Shapes } from '../../components/shared';

import { parseTitle } from '../../../utils/title-parser';

import Image from '../../components/shared/image.component';

import useResponsive from '../../../utils/responsive';

import { WordPressImageTransformer } from '../../../utils/wordpress-image-transformer';

const HeroSection = (props) => {

    const {
        isLeadGen,
        isLeadGenSales,
        title,
        id,
        subheading,
        paragraph,
        paragraphTwo,
        negativeMargin,
        imgSrc,
        imgAlt,
    } = props;
    
    const { isMobile, isTablet } = useResponsive();

    const isMainHeaderOne = true;

    const renderImageSection = () => {
        return (
            <div className='hero-section-image-container'>
                {renderImageSectionDesktop()}
                {renderImageSectionMobile()}
            </div>
        );
    };

    const renderImageSectionDesktop = () => {
        if (!isMobile || !isTablet) {
            const imgSrcDesktop = WordPressImageTransformer(imgSrc, 575, 100);
            if (isLeadGen || isLeadGenSales) {
                return (
                    <>
                        <Shapes
                            isCircle
                            isPair
                            isSmallDark
                            speed={0.03}
                            containerMargins={{ left: '-10%', top: '70%' }}
                            smallRadius={21}
                            largeRadius={50}
                            distanceBetween={{ width: '-110%', height: '30%' }}
                            zIndex={3}
                        />

                        <Shapes
                            isPair
                            isLargeDark
                            speed={0.25}
                            containerMargins={{ left: '90%', top: '10%' }}
                            degrees="30deg"
                            smallMargins={{ width: 50, height: 25 }}
                            largeMargins={{ width: 86, height: 43 }}
                            distanceBetween={{ width: '0%', height: '10%' }}
                            zIndex={3}
                        />

                        <Shapes
                            isDots
                            speed={-0.07}
                            containerMargins={{
                                top: id === 'about_header' ? '19%' : '8.5%',
                                left: id === 'about_header' ? '8%' : '15.5%',
                            }}
                            smallMargins={{ width: id === 'about_header' ? '50%' : '40%' }}
                            zIndex={1}
                        />

                        <div className='hero-section-hero-image-container'>
                            <Image className='hero-section-hero-image-lead-gen' src={imgSrcDesktop} alt={imgAlt} isOldImage />
                        </div>

                    </>
                );
            }
            return (
                <>
                    <Shapes
                        isCircle
                        isPair
                        isSmallDark
                        isOpposite={id !== 'about_header'}
                        speed={0.25}
                        containerMargins={{
                            left: id === 'about_header' ? '70%' : '83%',
                            top: id === 'about_header' ? '35%' : '27%',
                        }}
                        smallRadius={21}
                        largeRadius={50}
                        distanceBetween={{ width: '20%', height: '-5%' }}
                        zIndex={3}
                    />

                    <Shapes
                        isSingle
                        speed={0.03}
                        containerMargins={{ left: isLeadGenSales ? '-15%' : '-2%', top: '82%' }}
                        degrees="30deg"
                        largeMargins={{ width: 204.77, height: 102.39 }}
                        zIndex={3}
                    />

                    <Shapes
                        isDots
                        speed={-0.07}
                        containerMargins={{
                            top: id === 'about_header' ? '19%' : '8.5%',
                            left: id === 'about_header' ? '8%' : '15.5%',
                        }}
                        smallMargins={{ width: id === 'about_header' ? '50%' : '40%' }}
                        zIndex={1}
                    />

                    <div className='hero-section-hero-image-container'>
                        <Image className='hero-section-hero-image' src={imgSrcDesktop} alt={imgAlt} isOldImage />
                    </div>

                </>
            );
        }
        return null;
    };

    const renderImageSectionMobile = () => {
        if (isMobile && isTablet) {
            const imgSrcMobile = WordPressImageTransformer(imgSrc, 650, 100);
            if (isLeadGen || isLeadGenSales) {
                return (
                    <>
                        <Shapes
                            isPair
                            isLargeDark
                            speed={0.2}
                            containerMargins={{ left: '85%', top: '10%' }}
                            degrees="30deg"
                            smallMargins={{ width: 30.81, height: 15.41 }}
                            largeMargins={{ width: 52.99, height: 26.5 }}
                            distanceBetween={{ width: '0%', height: '10%' }}
                            zIndex={3}
                        />

                        <Shapes
                            isDots
                            speed={-0.07}
                            containerMargins={{
                                top: '0%',
                                left: '-30%',
                            }}
                            smallMargins={{ width: '50%' }}
                            zIndex={1}
                        />

                        <div className='hero-section-hero-image-container-mobile'>

                            <Image 
                                className='hero-section-hero-image-lead-gen'
                                src={imgSrcMobile}
                                alt={props.imgAlt}
                                isMobile
                                isOldImage
                            />

                        </div>

                    </>
                );
            }
            return (
                <>
                    <Shapes
                        isCircle
                        isPair
                        isSmallDark
                        isOpposite={id !== 'about_header'}
                        speed={0.15}
                        containerMargins={{
                            left: id === 'about_header' ? '80%' : '90%',
                            top: id === 'about_header' ? '45%' : '45%',
                        }}
                        smallRadius={9.73}
                        largeRadius={23.16}
                        distanceBetween={{ width: '20%', height: '-25%' }}
                        zIndex={3}
                    />
                    {isLeadGenSales ? null : (
                        <Shapes
                            isSingle
                            speed={0.015}
                            containerMargins={{
                                left: id === 'about_header' ? '10%' : '-7%',
                                top: '80%',
                            }}
                            degrees="30deg"
                            largeMargins={{ width: 94.85, height: 47.42 }}
                            zIndex={3}
                        />
                    )}
                    <Shapes
                        isDots
                        speed={-0.05}
                        containerMargins={{
                            top: id === 'about_header' ? '12%' : '5%',
                            left: id === 'about_header' ? '-25%' : '-55%',
                        }}
                        smallMargins={{ width: id === 'about_header' ? '34%' : '35%' }}
                        zIndex={2}
                    />
                    <div className='hero-section-hero-image-container'>
                        <Image className='hero-section-hero-image' src={imgSrcMobile} alt={imgAlt} isMobile isOldImage />
                    </div>
                </>
            );
        }

        return null;

    };    

    return (

        <div className='container-root container-root-maxWidthLg'>

            <div                
                className={`main-grid-container ${ isLeadGen || isLeadGenSales ? 'hero-section-hero-lead-gen-grid-container' : 'hero-section-grid-container'}`}
            >

                <div className='main-grid-item main-grid-md-6'>

                    <div className='hero-section-header'>{parseTitle(title, id, isMainHeaderOne)}</div>

                    <FadeInAnimation>

                        <div>

                            <h5 id="home_subheading">{subheading}</h5>

                            <p id="home_hero_paragraph" className='hero-section-paragraph'>
                                {paragraph}
                            </p>

                            <p id="home_hero_paragraph_two" className='hero-section-paragraph'>
                                {paragraphTwo}
                            </p>

                        </div>

                    </FadeInAnimation>

                </div>

                <div className={`main-grid-item main-grid-md-6 ${negativeMargin ? 'hero-section-negative-margin ' : null}`}>
                    {renderImageSection()}
                </div>

            </div>

        </div>

    );
};

export default HeroSection;

HeroSection.propTypes = {
    negativeMargin: PropTypes.bool,
    isLeadGen: PropTypes.string,
    isLeadGenSales: PropTypes.bool,
    title: PropTypes.string,
    subheading: PropTypes.string,
    paragraph: PropTypes.string,
    paragraphTwo: PropTypes.string,
    id: PropTypes.string,
    imgSrc: PropTypes.string,
    imgAlt: PropTypes.string,
};

